/**
 * 医评议项目工作空间（SelectionWorkspaceLayout）：与全局 MainLayout 平级。
 *
 * 列表为 `/selection/projects`，详情段为 `:pid`（评议项目 ID）。
 */
export const SELECTION_WORKSPACE_ROUTE_BASE = '/selection/projects';

/** 侧栏「返回」：评议项目列表 */
export const SELECTION_WORKSPACE_PARENT_PATH = '/selection/projects';
